import React, { Component } from 'react';
import './StatusFilter.css';
import CheckboxFilter from './CheckboxFilter';
import MenuType from '../enums/MenuType';
import PlotStatus from '../site/PlotStatus';
import Option from '../choices/Option';
import SubMenuHeader from './SubMenuHeader';
import UnitMarkerKey from './UnitMarkerKey';
import Tutorials from '../tutorials/Tutorials';
import ClickedOffManager from '../ui_core/ClickedOffManager';
export default class StatusFilter extends Component {
	constructor(props){
		super(props)
		const {onSelectedOptionsChange} = props;
		this._element = React.createRef();
		this._callbackSelectedOptionsChange=onSelectedOptionsChange;
		this._checkboxFilter=React.createRef();
		this._subMenuHeader = React.createRef();
		this._unitMarkerKey = React.createRef();
		this.load = this.load.bind(this);
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this.filterPlots = this.filterPlots.bind(this);
		this.clear = this.clear.bind(this);
		this._updateOptions= this._updateOptions.bind(this);
		this._iMenuManager  = null;
		this.state = {options:[], visible:false};
		this._clickedOffManager = new ClickedOffManager({elementRef:this._element, hide:this.hide});
	}
	show(){
		Tutorials.hasClickedFilterStatus=true;
		this.setState({visible:true});
		this._clickedOffManager.register();
	}
	hide(){
		this.setState({visible:false});
		this._clickedOffManager.dispose();
		this._iMenuManager.close();
	}
	filterPlots(plotsArray){
		const plotStatusesToShow = this._checkboxFilter.current.getCheckedValues();
		if(plotStatusesToShow.length<1)return plotsArray;
		return plotsArray.filter(plot=>plotStatusesToShow.indexOf(plot.status)>=0);
	}
	setForSale(){
		this._checkboxFilter.current.getCheckboxOptions().forEach(checkboxOption=>{
			checkboxOption = checkboxOption.ref.current;
			const checkboxOptionOption = checkboxOption.option;
			const newChecked = checkboxOptionOption.value===PlotStatus.AVAILABLE;
			checkboxOption.isChecked=newChecked;
		});
		this._callbackSelectedOptionsChange();
	}
	clear(){
		this._checkboxFilter.current.clear();
	}
	setIMenuManager(value){
		this._iMenuManager = value;
		this._subMenuHeader.current.setIMenuManager(value);
	}
	get menuType(){
		return MenuType.STATUS_FILTER;
	}
	get isApplied(){
		return this._checkboxFilter.current.isApplied;
	}
	setAvailableOnly(){
		const checkboxOption = this._checkboxFilter.current.getCheckboxOptions()
			.map(checkboxOption=>checkboxOption.ref.current)
			.forEach(checkboxOption=>{
				const plotStatus= checkboxOption.value;
				checkboxOption.isChecked =plotStatus===PlotStatus.AVAILABLE;
			});
	}
	load(plotsArray, siteJson){
		const plotStatusesForPlots = [];
		for(var i=0; i<plotsArray.length; i++){
			const plot = plotsArray[i];
			if(plotStatusesForPlots.indexOf(plot.status)<0)
				plotStatusesForPlots.push(plot.status);
		}
		this._updateOptions(plotStatusesForPlots);
		this._unitMarkerKey.current.load({plotsArray});
	}
	_updateOptions(plotStatusesForPlots){
		const options = plotStatusesForPlots
				.sort((a, b)=>PlotStatus.getDescription(a).localeCompare(PlotStatus.getDescription(b)))
				.map((plotStatus)=>{
			const option = new Option({text:PlotStatus.getDescription(plotStatus),
			value:plotStatus,
			className:PlotStatus.getCssName(plotStatus)})
			return option;
		});
		this._checkboxFilter.current.setOptions(options);
	}
	render() {
		let className ="status-filter menu";
		if(this.state.visible)
			className+=" visible";
		return (<div className={className} ref={this._element}>
				<SubMenuHeader ref={this._subMenuHeader} title="Availability"></SubMenuHeader>
				<CheckboxFilter ref={this._checkboxFilter} onSelectionChange={this._callbackSelectedOptionsChange}></CheckboxFilter>
				
				<UnitMarkerKey ref={this._unitMarkerKey}></UnitMarkerKey>
				</div>)
	}
}
